import { definePlugin } from '@zg-rentals/rp-bootstrap-base';
import { datadogRum } from '@datadog/browser-rum';
import { isbot } from 'isbot';

export type DatadogRumOptions = {
  sessionSampleRate?: number;
};

export default (
  applicationId: string,
  clientToken: string,
  service: string,
  version: string,
  env: string,
  options: DatadogRumOptions = {},
) =>
  definePlugin(() => {
    if (typeof window !== 'undefined') {
      datadogRum.init({
        applicationId,
        env,
        clientToken,
        service,
        version,
        sessionSampleRate: options.sessionSampleRate ?? 5,
        sessionReplaySampleRate: 0,
        trackUserInteractions: false,
        // Only inject Datadog's own headers, not the W3C traceparent: our BrowserTracer owns
        // traceparent (datarouter-compatible), and a Datadog-format one would get regenerated backend-side.
        allowedTracingUrls: [{ match: window.location.origin, propagatorTypes: ['datadog'] }],
        site: 'datadoghq.com',
        startSessionReplayRecordingManually: true,
        beforeSend: () => !isbot(window.navigator.userAgent),
      });
    }
  });
